<template>
  <div class="card">
    <div class="card-btn">
      <div
        class="default-btn flex-btn"
        @click="deleteTask"
        title="Delete This Task"
      >
        <svg
          height="25"
          width="25"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m 319.73683,110.87999 c -38.95639,-0.19999 -77.91294,-0.0401 -116.82944,-0.0401 -41.19624,0 -82.43238,-0.27998 -123.62877,0.15998 -20.558,0.19999 -25.43756,5.59949 -22.67785,25.67767 10.87897,79.2328 22.23792,158.38561 33.47687,237.53842 2.99986,21.19807 8.23925,25.67767 29.67741,25.71765 55.31489,0.0801 110.62994,0.0801 165.94485,0.0401 23.75794,0 29.11733,-5.87947 31.91709,-29.27734 9.03916,-76.07309 18.43845,-152.10618 28.31741,-228.05927 3.43979,-26.27762 0,-31.59714 -26.19757,-31.75711 z M 138.31334,358.13753 c -13.43874,1.63985 -18.47835,-9.15917 -19.83818,-20.51814 -6.51943,-54.75503 -12.63883,-109.59004 -18.95832,-164.34506 -1.23999,-10.87902 1.9598,-20.07819 13.27885,-21.95801 12.47879,-2.07982 18.55829,6.79937 20.03812,17.87837 4.27959,32.35707 7.99926,64.79411 11.83892,97.19117 2.63972,22.35798 5.1596,44.71595 7.71937,67.07391 1.19994,11.75894 -0.48057,23.0379 -14.07876,24.67776 z m 80.35272,-20.67813 c -0.0445,11.15899 -4.67962,21.27807 -16.95847,21.07808 -13.19875,-0.23998 -16.79843,-10.59903 -16.67858,-22.71793 0.28033,-26.99754 0.0742,-54.03509 0.0742,-81.03263 h -0.28033 c 0,-26.99756 0.11866,-54.03509 -0.0445,-81.03265 -0.0742,-11.59894 1.91976,-22.83792 15.63854,-23.55786 13.79872,-0.71996 17.79843,10.35906 17.87837,21.83802 0.44053,55.115 0.48057,110.26998 0.36043,165.42497 z m 86.75202,-162.66521 c -6.59937,54.75502 -13.51869,109.43006 -20.59804,164.14509 -1.44023,11.03899 -7.31934,20.51812 -19.4782,18.75829 -13.07891,-1.91983 -15.3186,-12.63885 -13.67888,-24.63777 3.67977,-26.75756 6.63943,-53.59513 10.07921,-80.3927 3.43963,-26.79756 6.95936,-53.55512 10.19905,-80.39268 1.40018,-11.51896 4.79947,-22.39797 18.51824,-21.39806 13.75883,0.99985 16.31861,12.51887 14.95862,23.91783 z M 169.67051,34.606917 c 6.71937,-33.5569512 10.19905,-37.0366353 32.717,-33.5169549 38.31653,5.999455 39.31639,7.2393427 34.31682,44.5559529 29.59732,5.239523 59.23467,10.919009 89.03191,15.598582 12.91887,2.039815 24.5178,5.039542 22.31801,21.038092 -2.35983,17.118439 -16.23851,14.758657 -27.83744,12.838833 C 251.42312,83.602465 182.66932,71.603557 113.91553,59.764632 98.95691,57.164869 84.03818,54.165141 68.99962,51.925343 56.92071,50.125508 49.96135,43.846078 52.04115,31.567193 54.20089,18.968337 63.84002,16.128596 75.19912,18.088417 c 31.51706,5.399511 62.99423,10.999001 94.47139,16.5185 z"
            style="stroke-width: 0.399963"
          />
          <path
            d="m 19.983552,6.9299778 c -2.434773,-0.012287 -4.869577,-0.0025 -7.30183,-0.0025 -2.574772,0 -5.1520016,-0.017638 -7.7267742,0.010075 -1.2848823,0.012288 -1.5898589,0.3499655 -1.4173862,1.6048509 0.6799372,4.9520333 1.3898902,9.8990683 2.0923155,14.8461063 0.1874017,1.324873 0.5149608,1.604848 1.8548353,1.607348 3.4571666,0.005 6.9143336,0.005 10.3715306,0.0025 1.484851,0 1.819844,-0.367468 1.994804,-1.829831 0.564945,-4.754553 1.152379,-9.506607 1.769828,-14.2536611 0.214803,-1.6423471 0,-1.9748166 -1.637323,-1.9848133 z M 8.644587,22.38353 C 7.8046811,22.486017 7.4896888,21.81108 7.4047124,21.101148 6.9972477,17.678971 6.6147909,14.251791 6.2198302,10.829614 6.1423502,10.149673 6.3423502,9.5747284 7.0497517,9.4572417 7.8296575,9.3272574 8.2096576,9.8822024 8.30213,10.574634 c 0.2674017,2.022313 0.4999687,4.049621 0.7399374,6.074431 0.1650394,1.39737 0.3224568,2.79474 0.4824568,4.192108 0.07496,0.734934 -0.031496,1.439865 -0.8799372,1.542357 z m 5.022018,-1.292382 c -0.0025,0.697437 -0.292284,1.329874 -1.059875,1.31738 -0.824945,-0.01511 -1.04989,-0.662441 -1.042425,-1.419871 0.01575,-1.687339 0.0063,-3.377179 0.0063,-5.064525 h -0.01575 c 0,-1.687339 0.0094,-3.377179 -0.0025,-5.064525 -0.0063,-0.724929 0.119685,-1.4273637 0.977386,-1.472359 0.862426,-0.045008 1.11241,0.647436 1.117386,1.36487 0.02835,3.444678 0.0315,6.891855 0.02205,10.33903 z m 5.422017,-10.166545 c -0.412473,3.422178 -0.844945,6.839357 -1.28737,10.259037 -0.08976,0.689935 -0.457449,1.282382 -1.217387,1.172391 -0.817417,-0.12 -0.957449,-0.789924 -0.854929,-1.539853 0.229922,-1.672346 0.41496,-3.349689 0.629953,-5.024531 0.214804,-1.674845 0.434961,-3.347189 0.637417,-5.024528 0.08756,-0.719934 0.299843,-1.3998679 1.157418,-1.3373734 0.859905,0.062489 1.019905,0.7824224 0.934898,1.4948574 z M 10.60443,2.1629274 c 0.419969,-2.09730467 0.637418,-2.31478508 2.044788,-2.09480717 2.394804,0.37496705 2.457292,0.45246006 2.144788,2.78474127 1.849859,0.327471 3.702143,0.6824348 5.564475,0.9749075 0.807465,0.127496 1.532377,0.3149702 1.394897,1.3148759 C 21.605977,6.2125445 20.738481,6.0650611 20.013536,5.9450704 15.713913,5.2251395 11.41684,4.4752085 7.119736,3.7352775 6.184838,3.5727893 5.2524282,3.3853121 4.3124908,3.2453215 3.5575616,3.1328178 3.1226007,2.7403701 3.252585,1.9729431 3.3877032,1.185516 3.9900341,1.0080324 4.6999556,1.1305207 6.669783,1.4679918 8.6371223,1.8179603 10.60443,2.1629274 Z"
            style="stroke-width: 0.0199981"
            class="svg"
          />
        </svg>
      </div>
      <div
        class="main-btn flex-btn"
        @click="markCompleted"
        title="Mark as Complete"
      >
        <svg
          height="40"
          width="40"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m 39.440652,7.0077198 -6.144,-4.964 c -0.644,-0.52 -1.6,-0.42 -2.124,0.228 l -16.768,20.7680002 -6.5679996,-5.968 c -0.616,-0.564 -1.576,-0.512 -2.136,0.1 l -5.30800001,5.84 c -0.56,0.616 -0.516,1.576 0.1,2.136 l 14.03999961,12.764 c 0.616,0.56 1.544,0.488 2.068,-0.16 l 4.952,-6.176 c 0.008,-0.008 0.008,-0.02 0.016,-0.036 l 18.1,-22.4080002 c 0.52,-0.644 0.416,-1.604 -0.228,-2.124 z"
            style="stroke-width: 0.04"
            class="svg"
          />
        </svg>
      </div>
      <div
        class="default-btn flex-btn"
        @click="showModal = true"
        title="Edit This Task"
      >
        <svg
          height="23"
          width="23"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m 1.0099635,21.11212 c 0.6115897,-2.098764 1.2209793,-4.197529 1.8325691,-6.296294 0.048399,-0.167196 0.098999,-0.334394 0.1429975,-0.501591 0.070399,-0.252995 0.2023967,-0.457592 0.4047933,-0.626989 0.1891967,-0.156198 0.3563939,-0.343194 0.530191,-0.516992 2.8665516,-2.840151 5.7331034,-5.6803037 8.5974556,-8.5226558 0.066,-0.065999 0.123196,-0.1407977 0.169396,-0.1979967 0.389394,0.3915935 0.754587,0.7589871 1.161581,1.1681803 -0.044,0.030799 -0.129798,0.074799 -0.195797,0.1407977 -2.969949,2.9633501 -5.9376996,5.9266995 -8.9010496,8.8966505 -0.1055978,0.1078 -0.1935967,0.255196 -0.2353961,0.400392 -0.3563939,1.176981 -0.6951882,2.36056 -1.0471823,3.541941 -0.043999,0.147397 -0.022,0.239796 0.090199,0.340994 0.1825969,0.164998 0.3431941,0.354195 0.5279911,0.516992 0.063799,0.055 0.1847969,0.0968 0.2617957,0.077 1.18358,-0.338794 2.3649601,-0.684189 3.54414,-1.040582 0.1011978,-0.0308 0.1957969,-0.116599 0.2749955,-0.197997 3.0117487,-3.002949 6.0190977,-6.010299 9.0264467,-9.0154478 0.0572,-0.0572 0.1056,-0.1209982 0.138598,-0.1583973 0.426792,0.4267928 0.840386,0.8403858 1.293577,1.2935781 -0.0198,0.0132 -0.099,0.0462 -0.153996,0.101197 -2.96555,2.93695 -5.9355,5.867303 -8.8856497,8.819653 -0.411393,0.413592 -0.8579854,0.668787 -1.410176,0.824985 -1.9579671,0.554391 -3.9071342,1.139581 -5.8607013,1.713772 -0.1297977,0.0374 -0.2617955,0.0726 -0.3915935,0.11 H 1.749151 C 1.6545525,21.94151 1.5577542,21.90411 1.4631558,21.86011 1.1991603,21.73691 1.1089618,21.486113 1.0099635,21.241918 Z M 6.9256636,17.466781 C 6.8684647,17.101588 6.8068658,16.767195 6.7672664,16.4328 6.7474668,16.274403 6.6836678,16.210603 6.5296704,16.182004 6.1534768,16.109404 5.781683,16.014806 5.4340889,15.937807 8.5536363,12.811661 11.673183,9.6833136 14.772931,6.5747657 15.267923,7.0697573 15.784914,7.5845486 16.284305,8.0817403 13.195557,11.179289 10.07821,14.305435 6.9256636,17.466781 Z M 15.910311,1.3938532 c 0.281595,-0.2749954 0.563192,-0.56759056 0.864586,-0.84038594 0.864586,-0.77878688 1.990966,-0.76118717 2.833552,0.0615988 0.930585,0.90638479 1.847969,1.82376939 2.754354,2.75435369 0.857986,0.8777852 0.844786,2.0525653 -0.011,2.9281507 C 22.094407,6.561566 21.828212,6.8189616 21.581815,7.0609575 19.698648,5.1799892 17.817679,3.301221 15.910311,1.3938532 Z M 13.61575,3.4706181 c 0.426793,-0.4003933 0.864586,-0.8117863 1.280378,-1.2033798 1.971168,1.9711667 3.931334,3.9335337 5.909101,5.9113003 -0.411393,0.3849936 -0.853586,0.8007863 -1.280378,1.20118 z"
            style="stroke-width: 0.0249996"
            class="svg"
          />
        </svg>
      </div>
    </div>
    <div class="card-drag">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <div class="card-item">
      <h2>{{ task.title }}</h2>
      <p class="note">Note:</p>
      <p>
        {{ task.note }}
      </p>
    </div>
  </div>

  <Modal @close="showModal = false" v-if="showModal">
    <template v-slot>
      <Form v-model:isOpen="showModal" :taskItem="task" />
    </template>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import Form from "./EditForm.vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
export default {
  props: ["task"],
  components: { Modal, Form },
  setup(props) {
    const showModal = ref(false);
    const store = useStore();

    function markCompleted() {
      const d = new Date();
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      let obj = {
        id: props.task.id,
        title: props.task.title,
        note: props.task.note,
        dateFinish: {
          date: ("0" + d.getDate()).slice(-2),
          day: days[d.getDay()],
          month: months[d.getMonth()] + " " + d.getFullYear(),
          hour:
            ("0" + d.getHours()).slice(-2) +
            ":" +
            ("0" + d.getMinutes()).slice(-2),
        },
      };
      store.commit("addComplete", obj);
    }
    function deleteTask() {
      store.commit("removeTask", props.task);
    }
    return { showModal, markCompleted, deleteTask };
  },
};
</script>

<style scoped>
.card {
  background: #eef4d7;
  border-radius: 20px;
  border: 4px solid #5a2ca0;
  position: relative;
  margin-bottom: 30px;
  height: 200px;
  padding: 13px 20px 20px;
}

.card-btn {
  width: 100%;
  height: 60px;
  position: absolute;
  bottom: -30px;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-drag {
  width: 100px;
  height: 16px;
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: #5a2ca0;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: all-scroll;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: whitesmoke;
}
.dot:not(:last-child) {
  margin-right: 5px;
}
.flex-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-btn .default-btn {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 3px solid #5a2ca0;
  background: #eef4d7;
  cursor: pointer;
}

.card-btn .default-btn .svg {
  fill: #5a2ca0;
}
.card-btn .default-btn:hover,
.card-btn .default-btn:active {
  background: #5a2ca0;
}

.card-btn .default-btn:hover .svg,
.card-btn .default-btn:active .svg {
  fill: #eef4d7;
}

.card-btn .main-btn {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #5a2ca0;
  margin: 0 5px;
  border: 3px solid #5a2ca0;
  cursor: pointer;
}

.card-btn .main-btn .svg {
  fill: #eef4d7;
}

.card-btn .main-btn:hover,
.card-btn .main-btn:active {
  background: #eef4d7;
}

.card-btn .main-btn:hover .svg,
.card-btn .main-btn:active .svg {
  fill: #5a2ca0;
}

.card-item {
  overflow-y: auto;
  height: 100%;
  padding-bottom: 15px;
}

.card-item::-webkit-scrollbar-track {
  border-radius: 12px;
  background: #5a2ca0;
}
.card-item::-webkit-scrollbar-thumb {
  background: #00a383;
  border-radius: 10px;
}
.card-item::-webkit-scrollbar-thumb:hover {
  background: #abc837;
}

.card h2 {
  text-align: center;
  margin-bottom: 20px;
}

.card p {
  line-height: 1.5;
}

.card p.note {
  font-weight: bold;
  font-style: italic;
  line-height: 1;
  border-bottom: 2px solid black;
  display: inline-block;
  padding: 0 15px 0 3px;
  margin-bottom: 5px;
}
</style>
